module.exports = __webpack_public_path__ + "src/assets/games/26/471.jpg";